// @generated
// THIS FILE WAS AUTOMATICALLY GENERATED AND SHOULD NOT BE EDITED
/* eslint-disable */
import type * as Types from '../../../__generated-gql-types__/globalTypes';

import { gql } from '@apollo/client';
export type ClientOutcomesCoachFragment = {
  __typename?: 'Coach';
  id: string;
  outcomes?: Array<
    | {
        __typename?: 'CareerOutcomeSummary';
        companies: Array<{
          __typename?: 'Company';
          id?: string | null;
          name: string;
          logoLink?: string | null;
        }>;
      }
    | {
        __typename?: 'SchoolOutcomeSummary';
        schools: Array<{
          __typename?: 'School';
          id: string;
          name: string;
          logoLink?: string | null;
        }>;
      }
    | { __typename?: 'TestOutcomeSummary' }
  > | null;
};

export const ClientOutcomesCoachFragmentDoc = gql`
  fragment ClientOutcomes_Coach on Coach {
    id
    outcomes {
      ... on CareerOutcomeSummary {
        companies {
          id
          name
          logoLink
        }
      }
      ... on SchoolOutcomeSummary {
        schools {
          id
          name
          logoLink
        }
      }
    }
  }
`;
